import mixpanel from 'mixpanel-browser';

const TOKEN_FROM_ENV = process.env.REACT_APP_MIXPANEL_TOKEN;
const isLocalhost = typeof window !== 'undefined' && /^(localhost|127\.|\[::1\])/.test(window.location.hostname);
const isProduction = (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production');
const LOCAL_OPT_OUT_KEY = 'felt__mp_opt_out';

let initialized = false;

export function initMixpanel(token, options = {}) {
  if (initialized || !token) return;
  // Gate: do not initialize on localhost or when explicitly opted out
  try {
    const isOptedOut = (typeof window !== 'undefined') && window.localStorage.getItem(LOCAL_OPT_OUT_KEY) === '1';
    if (isLocalhost || isOptedOut) return;
  } catch (_) {}
  // Optional: only run in production
  if (!isProduction) return;
  try {
    mixpanel.init(token, {
      debug: false,
      track_pageview: false,
      // Do not force persistence type to avoid console errors in some environments
      cookie_domain: '.catbears.com',
      ...options,
    });
    initialized = true;
  } catch (_) {
    // ignore
  }
}

export function identify(userId, props = {}) {
  if (!initialized || !userId) return;
  try {
    mixpanel.identify(userId);
    if (props && Object.keys(props).length) {
      mixpanel.people && mixpanel.people.set(props);
    }
  } catch (_) {}
}

export function track(event, props = {}) {
  if (!initialized && TOKEN_FROM_ENV) {
    try { initMixpanel(TOKEN_FROM_ENV); } catch (_) {}
  }
  if (!initialized) return;
  try { mixpanel.track(event, props); } catch (_) {}
}

export function register(props = {}) {
  if (!initialized && TOKEN_FROM_ENV) {
    try { initMixpanel(TOKEN_FROM_ENV); } catch (_) {}
  }
  if (!initialized) return;
  try { mixpanel.register(props); } catch (_) {}
}

export function optOutAnalytics() {
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(LOCAL_OPT_OUT_KEY, '1');
    }
    try { mixpanel.opt_out_tracking(); } catch (_) {}
  } catch (_) {}
}

export function optInAnalytics() {
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.removeItem(LOCAL_OPT_OUT_KEY);
    }
    try { mixpanel.opt_in_tracking(); } catch (_) {}
  } catch (_) {}
}

// URL toggles for quick control: ?mp=off / ?mp=on
try {
  if (typeof window !== 'undefined') {
    const p = new URLSearchParams(window.location.search);
    const val = (p.get('mp') || '').toLowerCase();
    if (val === 'off') optOutAnalytics();
    if (val === 'on') optInAnalytics();
  }
} catch(_) {}


